<template>
    <div class="content">
        <base-header class="pb-6">
            <div class="row align-items-center py-4">
                <div class="col-lg-6 col-7">
                    <h6 class="h2 text-white d-inline-block mb-0">
                        Coupon Log
                    </h6>
                    <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
                        <route-bread-crumb></route-bread-crumb>
                    </nav>
                </div>
            </div>
        </base-header>
        <div class="container-fluid mt--6">
            <div>
                <card class="no-border-card" body-classes="px-0 pb-1" footer-classes="pb-2">
                    <template slot="header">
                        <div class="row">
                            <div class="col-md-2">
                                <base-input label="วันที่เริ่มต้น">
                                    <flat-picker
                                        v-model="params.date_from"
                                        :config="{ allowInput: true, dateFormat: 'Y-m-d' }"
                                        class="form-control datepicker"
                                        placeholder="เลือกวันที่"
                                    ></flat-picker>
                                </base-input>
                            </div>
                            <div class="col-md-2">
                                <base-input label="วันที่สิ้นสุด">
                                    <flat-picker
                                        v-model="params.date_to"
                                        :config="{ allowInput: true, dateFormat: 'Y-m-d' }"
                                        class="form-control datepicker"
                                        placeholder="เลือกวันที่"
                                    ></flat-picker>
                                </base-input>
                            </div>
                            <div class="col-md-2">
                                <base-input label="ประเภท">
                                    <el-select v-model="params.action_type" placeholder="ทั้งหมด" clearable>
                                        <el-option label="ทั้งหมด" value=""></el-option>
                                        <el-option label="CLEAR_ORDER" value="CLEAR_ORDER"></el-option>
                                        <el-option label="SET_ORDER" value="SET_ORDER"></el-option>
                                        <el-option label="LINK_COUPON" value="LINK_COUPON"></el-option>
                                    </el-select>
                                </base-input>
                            </div>
                            <div class="col-md-2">
                                <base-input label="Order ID" v-model="params.order_id" placeholder="Order ID"></base-input>
                            </div>
                            <div class="col-md-2">
                                <base-input label="Coupon Detail ID" v-model="params.coupon_detail_id" placeholder="Coupon Detail ID"></base-input>
                            </div>
                            <div class="col-auto d-flex align-items-end pb-3">
                                <base-button size="md" type="primary" @click="handleSearch()">
                                    <i class="fas fa-spinner fa-spin" v-if="isSearching"></i>
                                    ค้นหา
                                </base-button>
                                <base-button size="md" type="default" @click="handleReset()">Reset</base-button>
                            </div>
                        </div>
                        <div class="row" v-if="headId">
                            <div class="col mt-2">
                                <span class="badge badge-info">Coupon ID: {{ headId }}</span>
                                <base-button size="sm" type="link" @click="goBack()">
                                    <i class="fas fa-arrow-left"></i> กลับไปหน้า Coupon Detail
                                </base-button>
                            </div>
                        </div>
                    </template>

                    <div>
                        <el-table :data="tableData" row-key="id" header-row-class-name="thead-light" v-loading="isSearching">
                            <el-table-column align="left" label="วันที่" min-width="160px">
                                <div slot-scope="{ row }">
                                    {{ formatDate(row.created_at) }}
                                </div>
                            </el-table-column>

                            <el-table-column align="left" label="Running Number" min-width="140px">
                                <div slot-scope="{ row }">
                                    {{ row.running_number }}
                                </div>
                            </el-table-column>

                            <el-table-column align="left" label="Action" min-width="120px">
                                <div slot-scope="{ row }">
                                    <span :class="getActionBadgeClass(row.action_type)">
                                        {{ row.action_type }}
                                    </span>
                                </div>
                            </el-table-column>

                            <el-table-column align="left" label="Old Order" min-width="100px">
                                <div slot-scope="{ row }">
                                    {{ row.old_bo_order_id || '-' }}
                                </div>
                            </el-table-column>

                            <el-table-column align="left" label="New Order" min-width="100px">
                                <div slot-scope="{ row }">
                                    {{ row.new_bo_order_id || '-' }}
                                </div>
                            </el-table-column>

                            <el-table-column align="left" label="Tracking" min-width="140px">
                                <div slot-scope="{ row }">
                                    {{ row.order_tracking_number || '-' }}
                                </div>
                            </el-table-column>

                            <el-table-column align="left" label="ผู้ดำเนินการ" min-width="120px">
                                <div slot-scope="{ row }">
                                    {{ row.bo_user_name }}
                                </div>
                            </el-table-column>

                            <el-table-column align="left" label="เหตุผล" min-width="150px">
                                <div slot-scope="{ row }">
                                    {{ row.reason || '-' }}
                                </div>
                            </el-table-column>

                            <el-table-column align="right" label="Actions" min-width="80px">
                                <div slot-scope="{ row }">
                                    <base-button @click="handleDetail(row)" type="warning" size="sm" icon>
                                        <i class="fa fa-eye"></i>
                                    </base-button>
                                </div>
                            </el-table-column>
                        </el-table>
                    </div>

                    <div slot="footer" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
                        v-if="tableData.length > 0">
                        <div class="">
                            <p class="card-category">
                                รายการที่ {{ from + 1 }} ถึง {{ to }} จากทั้งหมด {{ pagination.total }} รายการ
                            </p>
                        </div>
                        <base-pagination
                            class="pagination-no-border"
                            v-model="pagination.currentPage"
                            :per-page="pagination.perPage"
                            :total="pagination.total"
                            @input="handlePageChange"
                        >
                        </base-pagination>
                    </div>

                    <div v-if="tableData.length === 0 && !isSearching" class="text-center py-4">
                        <p class="text-muted">ไม่พบข้อมูล</p>
                    </div>
                </card>
            </div>
        </div>

        <!-- Detail Modal -->
        <modal :show.sync="showDetailModal" modal-classes="modal-secondary">
            <template slot="header">
                <div class="d-flex align-items-center w-100" v-if="selectedLog">
                    <div class="icon icon-shape bg-gradient-primary text-white rounded-circle shadow mr-3">
                        <i class="fas fa-history"></i>
                    </div>
                    <div>
                        <h5 class="modal-title mb-0">{{ selectedLog.running_number }}</h5>
                        <small class="text-muted">{{ formatDate(selectedLog.created_at) }}</small>
                    </div>
                    <span :class="getActionBadgeClass(selectedLog.action_type)" class="ml-auto">
                        {{ selectedLog.action_type }}
                    </span>
                </div>
                <h5 v-else class="modal-title">Log Detail</h5>
            </template>
            <div v-if="selectedLog">
                <!-- Coupon Info Section -->
                <h6 class="text-uppercase text-muted ls-1 mb-3">
                    <i class="fas fa-ticket-alt mr-2"></i>Coupon Info
                </h6>
                <div class="row mb-2">
                    <div class="col-5 text-muted">Coupon Head ID:</div>
                    <div class="col-7 font-weight-bold">{{ selectedLog.coupon_head_id }}</div>
                </div>
                <div class="row mb-2">
                    <div class="col-5 text-muted">Coupon Detail ID:</div>
                    <div class="col-7 font-weight-bold">{{ selectedLog.coupon_detail_id }}</div>
                </div>

                <hr class="my-3">

                <!-- Order Info Section -->
                <h6 class="text-uppercase text-muted ls-1 mb-3">
                    <i class="fas fa-shopping-cart mr-2"></i>Order Info
                </h6>
                <div class="row mb-2">
                    <div class="col-5 text-muted">Old Order ID:</div>
                    <div class="col-7">
                        <span v-if="selectedLog.old_bo_order_id" class="font-weight-bold">{{ selectedLog.old_bo_order_id }}</span>
                        <span v-else class="text-muted">-</span>
                    </div>
                </div>
                <div class="row mb-2">
                    <div class="col-5 text-muted">New Order ID:</div>
                    <div class="col-7">
                        <span v-if="selectedLog.new_bo_order_id" class="font-weight-bold text-success">{{ selectedLog.new_bo_order_id }}</span>
                        <span v-else class="text-muted">-</span>
                    </div>
                </div>
                <div class="row mb-2">
                    <div class="col-5 text-muted">Tracking Number:</div>
                    <div class="col-7">{{ selectedLog.order_tracking_number || '-' }}</div>
                </div>

                <hr class="my-3">

                <!-- User Info Section -->
                <h6 class="text-uppercase text-muted ls-1 mb-3">
                    <i class="fas fa-user mr-2"></i>User Info
                </h6>
                <div class="row mb-2">
                    <div class="col-5 text-muted">ผู้ดำเนินการ:</div>
                    <div class="col-7 font-weight-bold">{{ selectedLog.bo_user_name }}</div>
                </div>
                <div class="row mb-2">
                    <div class="col-5 text-muted">User ID:</div>
                    <div class="col-7">{{ selectedLog.bo_user_id }}</div>
                </div>
                <div class="row mb-2">
                    <div class="col-5 text-muted">IP Address:</div>
                    <div class="col-7"><code>{{ selectedLog.ip_address || '-' }}</code></div>
                </div>

                <hr class="my-3">

                <!-- Reason Section -->
                <h6 class="text-uppercase text-muted ls-1 mb-3">
                    <i class="fas fa-comment-alt mr-2"></i>Details
                </h6>
                <div class="row mb-2">
                    <div class="col-5 text-muted">เหตุผล:</div>
                    <div class="col-7">{{ selectedLog.reason || '-' }}</div>
                </div>
                <div class="row mb-2">
                    <div class="col-5 text-muted">หมายเหตุ:</div>
                    <div class="col-7">{{ selectedLog.note || '-' }}</div>
                </div>
            </div>
            <template slot="footer">
                <base-button type="secondary" @click="showDetailModal = false">
                    <i class="fas fa-times mr-1"></i>ปิด
                </base-button>
            </template>
        </modal>
    </div>
</template>

<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination, Modal } from "@/components";
import { mapGetters, mapActions } from "vuex";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import moment from 'moment';

export default {
    components: {
        flatPicker,
        BasePagination,
        Modal,
        RouteBreadCrumb,
        [Select.name]: Select,
        [Option.name]: Option,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn
    },
    computed: {
        ...mapGetters({
            couponLogs: "Coupon/getCouponLogs",
            logsPagination: "Coupon/getLogsPagination",
        }),
        tableData() {
            return this.couponLogs || [];
        },
        from() {
            return (this.pagination.currentPage - 1) * this.pagination.perPage;
        },
        to() {
            const end = this.pagination.currentPage * this.pagination.perPage;
            return end > this.pagination.total ? this.pagination.total : end;
        }
    },
    data() {
        return {
            headId: '',
            isSearching: false,
            showDetailModal: false,
            selectedLog: null,
            params: {
                date_from: moment().subtract(30, 'days').format('YYYY-MM-DD'),
                date_to: moment().format('YYYY-MM-DD'),
                action_type: '',
                order_id: '',
                coupon_detail_id: '',
                head_id: ''
            },
            pagination: {
                perPage: 50,
                currentPage: 1,
                total: 0
            }
        };
    },
    watch: {
        logsPagination: {
            handler(val) {
                if (val) {
                    this.pagination.total = val.total || 0;
                }
            },
            deep: true
        }
    },
    mounted() {
        this.headId = this.$route.params.id || '';
        if (this.headId) {
            this.params.head_id = this.headId;
        }
        this.handleSearch();
    },
    methods: {
        ...mapActions({
            listCouponLogs: "Coupon/listCouponLogs",
            clearCouponLogs: "Coupon/clearCouponLogs",
        }),

        async handleSearch() {
            this.isSearching = true;
            try {
                const searchParams = {
                    page: this.pagination.currentPage,
                    page_size: this.pagination.perPage
                };

                if (this.params.date_from) {
                    searchParams.date_from = this.params.date_from;
                }
                if (this.params.date_to) {
                    searchParams.date_to = this.params.date_to;
                }
                if (this.params.action_type) {
                    searchParams.action_type = this.params.action_type;
                }
                if (this.params.order_id) {
                    searchParams.order_id = parseInt(this.params.order_id);
                }
                if (this.params.coupon_detail_id) {
                    searchParams.coupon_detail_id = parseInt(this.params.coupon_detail_id);
                }
                if (this.params.head_id) {
                    searchParams.head_id = parseInt(this.params.head_id);
                }

                await this.listCouponLogs(searchParams);
            } catch (error) {
                console.error('Error fetching logs:', error);
            } finally {
                this.isSearching = false;
            }
        },

        handleReset() {
            this.params = {
                date_from: moment().subtract(30, 'days').format('YYYY-MM-DD'),
                date_to: moment().format('YYYY-MM-DD'),
                action_type: '',
                order_id: '',
                coupon_detail_id: '',
                head_id: this.headId || ''
            };
            this.pagination.currentPage = 1;
            this.handleSearch();
        },

        handlePageChange(page) {
            this.pagination.currentPage = page;
            this.handleSearch();
        },

        handleDetail(row) {
            this.selectedLog = row;
            this.showDetailModal = true;
        },

        goBack() {
            if (this.headId) {
                this.$router.push("/backoffice/coupon/detail/" + this.headId);
            } else {
                this.$router.push("/backoffice/coupon");
            }
        },

        formatDate(dateStr) {
            if (!dateStr) return '-';
            return moment(dateStr).format('DD/MM/YYYY HH:mm:ss');
        },

        getActionBadgeClass(actionType) {
            switch (actionType) {
                case 'CLEAR_ORDER':
                    return 'badge badge-danger';
                case 'SET_ORDER':
                    return 'badge badge-success';
                case 'LINK_COUPON':
                    return 'badge badge-info';
                default:
                    return 'badge badge-secondary';
            }
        }
    },
    beforeDestroy() {
        this.clearCouponLogs();
    }
};
</script>

<style scoped>
.no-border-card .card-footer {
    border-top: 0;
}
</style>
